import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "subtitle", "submit", "vars"]
  static values = {
    title: String,
    subtitle: String,
    submit: String,
    btnClass: { type: String, default: "btn-primary" },
  }

  titleTargetConnected(_) {
    this.titleTarget.textContent = this.replaceVars(this.titleValue);
  }

  subtitleTargetConnected(_) {
    this.subtitleTarget.innerHTML = this.replaceVars(this.subtitleValue);
  }

  submitTargetConnected(_) {
    this.submitTarget.value = this.replaceVars(this.submitValue);
    this.submitTarget.classList.add(this.btnClassValue);
  }

  replaceAllVars() {
    this.titleTargetConnected();
    this.subtitleTargetConnected();
    this.submitTargetConnected();
  }

  replaceVars(str) {
    this.varsTargets.forEach((varElement) => {
      const value = varElement.dataset.varsTransform && window[varElement.dataset.varsTransform] ? window[varElement.dataset.varsTransform](varElement.value) : varElement.value;
      str = str.replace(`{{${varElement.name}}}`, value);
    });

    return str;
  }
}
